enum ROUTE_ENUM {
  SUCCESS = "success",
  ERROR = "error",
  LOADING = "loading",
  TIME = "time",
}

export default ROUTE_ENUM;
